import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonToggle } from '@ionic/react'
import './index.scss'

interface IProps {
  disabled?: boolean;
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

const MktEmpty: FC<IProps> = (props) => {
  const { disabled, checked, onChange } = props
  return (
    <IonToggle
      className='mkt-toggle'
      disabled={disabled}
      checked={checked}
      onIonChange={(e: any) => onChange && onChange(e.detail.checked)}
    >
    </IonToggle>
  )
}

export default observer(MktEmpty)
